document.addEventListener("DOMContentLoaded", () => {
    const inputFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>("input:not([type='checkbox']), textarea");

    inputFields.forEach(field => {
        field.addEventListener("input", () => {
            if (field.value.trim() !== "") {
                field.classList.add("filled");
            } else {
                field.classList.remove("filled");
            }
        });

        // Initial check in case the field is pre-filled
        if (field.value.trim() !== "") {
            field.classList.add("filled");
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // Alle "submit"-Buttons suchen
    const submitButtons = document.querySelectorAll('button[type="submit"]');

    // Durch die gefundenen Buttons iterieren
    submitButtons.forEach((button, index) => {
        // Klick-Event-Listener hinzufügen
        button.addEventListener('click', (event) => {
            // Das Formular finden, zu dem der Button gehört
            const form = button.closest('form');
            if (form) {
                // Alle Eingabefelder im Formular finden
                const inputs = form.querySelectorAll('input');

                // Über die Eingabefelder iterieren und die Klasse ".invalid" hinzufügen, wenn das Feld ungültig ist
                inputs.forEach(input => {
                    if (!input.validity.valid) {
                        input.classList.add('invalid');

                        // Standard-Submit verhindern
                        event.preventDefault();
                    } else {
                        input.classList.remove('invalid');
                    }

                    // Event-Listener für Änderungen an den Eingabefeldern hinzufügen
                    input.addEventListener('input', () => {
                        input.classList.remove('invalid');
                    });
                });
            }
        });
    });
});


